export default __webpack_public_path__ + "static/media/Logo.af829eaf.png";